/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomSmsOAuth
 */
export interface CustomSmsOAuth {
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    url: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    clientIdPlain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    clientSecretPlain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    scope?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    grantType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsOAuth
     */
    audience?: string | null;
}

/**
 * Check if a given object implements the CustomSmsOAuth interface.
 */
export function instanceOfCustomSmsOAuth(value: object): value is CustomSmsOAuth {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function CustomSmsOAuthFromJSON(json: any): CustomSmsOAuth {
    return CustomSmsOAuthFromJSONTyped(json, false);
}

export function CustomSmsOAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSmsOAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'clientIdPlain': json['client_id_plain'] == null ? undefined : json['client_id_plain'],
        'clientSecretPlain': json['client_secret_plain'] == null ? undefined : json['client_secret_plain'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'grantType': json['grant_type'] == null ? undefined : json['grant_type'],
        'audience': json['audience'] == null ? undefined : json['audience'],
    };
}

export function CustomSmsOAuthToJSON(json: any): CustomSmsOAuth {
    return CustomSmsOAuthToJSONTyped(json, false);
}

export function CustomSmsOAuthToJSONTyped(value?: CustomSmsOAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'client_id_plain': value['clientIdPlain'],
        'client_secret_plain': value['clientSecretPlain'],
        'scope': value['scope'],
        'grant_type': value['grantType'],
        'audience': value['audience'],
    };
}

